import {
  Autocomplete,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useController } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { BackButton } from "./Button";

const StyledText = styled(TextField)({
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

export const ReadonlyText = ({ field }) => (
  <StyledText
    type="text"
    name={field.name}
    label={field.label}
    value={field.value ?? ""}
    InputProps={{ disabled: true }}
    fullWidth
  />
);

export const CustomSwitch = ({ field, onChange }) => {
  const { label, name, value, tabIndex, checked } = field;
  const switchProps = {
    name,
    checked,
    onChange,
    ...(tabIndex && { inputProps: { tabIndex } }),
  };
  return (
    <FormControl
      sx={{
        margin: "-8px 0 12px 0",
        padding: "8px",
        height: "50px",
        borderRadius: ".375rem",
        border: "1px solid #d6d2da",
      }}
      component="fieldset"
      fullWidth
    >
      <FormLabel
        sx={{ "&.Mui-focused": { color: "#1A73E8" }, padding: "0 4px", fontSize: "12px" }}
        component="legend"
      >
        {label}
      </FormLabel>
      <FormGroup sx={{ marginTop: "-12px" }}>
        <Switch {...switchProps} />
      </FormGroup>
    </FormControl>
  );
};

const StyledDatePicker = styled(DatePicker)({
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6c6d6e",
  },
  ".MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#6c6d6e",
    },
  },
});

export const CustomDatePicker = (props) => {
  const {
    value,
    name,
    required = false,
    onChange,
    errors = {},
    disableClearable = false,
    ...field
  } = props.field;
  // label, name, disabled

  const inputProps = {
    ...field,
    name,
    format: "DD / MM / YYYY",
    value: value === null ? null : dayjs(value),
    onChange: (v) => {
      if (v) {
        onChange(dayjs(v).format("YYYY-MM-DD"));
      } else {
        onChange(null);
      }
    },
    slotProps: {
      textField: {
        sx: { mb: 1.5 },
        fullWidth: true,
        ...(required && { required }),
        ...(errors[name] && { error: true, helperText: errors[name].message }),
      },
      actionBar: {
        ...(!disableClearable && { actions: ["clear"] }),
      },
    },
  };
  return <StyledDatePicker {...inputProps} />;
};

export const CustomDateRangePicker = ({ startDate, setStartDate, endDate, setEndDate }) => {
  console.log({ startDate, setStartDate, endDate, setEndDate });
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <CustomDatePicker
          field={{
            label: "Start Date",
            name: "startDate",
            value: startDate,
            onChange: setStartDate,
            disableClearable: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <CustomDatePicker
          field={{
            label: "End Date",
            name: "endDate",
            value: endDate,
            onChange: setEndDate,
            disableClearable: true,
          }}
        />
      </Grid>
    </Grid>
  );
};
